import {Button} from "@mui/material";
import React from "react";


const ButtonAttention = (props) => {
    return (
        <Button {...props} variant="contained" className={`comp-button button-attention ${props.className ? props.className : ''}`} />
    );
}
export {ButtonAttention};